import React from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { ArrowRightIcon, ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { programs } from '../../data/programs';
import { site } from '../../data/site';
import { usePrograms } from '../../contexts/ProgramContext';
import { ButtonLink } from '../ui/ButtonLink';
export function ProgramDetail() {
  const {
    activeId,
    setActiveId,
    setTrialChoice
  } = usePrograms();
  const reduce = useReducedMotion();
  const index = programs.findIndex(p => p.id === activeId);
  const program = programs[index];
  const prev = programs[(index - 1 + programs.length) % programs.length];
  const next = programs[(index + 1) % programs.length];
  return <div id="program-detail" tabIndex={-1} aria-live="polite" className="on-dark mt-8 overflow-hidden rounded bg-ink text-white outline-none focus-visible:outline-sun lg:mt-10" data-id="element-183" data-mp="2e74ewgwpzsjx">
      <AnimatePresence mode="wait" initial={false} data-id="element-184" data-mp="3pivf8co6thw3">
        <motion.div key={program.id} initial={reduce ? false : {
        opacity: 0,
        y: 8
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={reduce ? {
        opacity: 0
      } : {
        opacity: 0,
        y: -6
      }} transition={{
        duration: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} className="grid lg:grid-cols-12" data-id="element-185" data-mp="ibgd2wz55wzs">
          <div className="p-6 sm:p-10 lg:col-span-7 lg:p-12" data-id="element-186" data-mp="4adtcqvmcys1">
            <p className="text-sm font-semibold text-sun" data-id="element-187" data-mp="3vi01avpdfnep">{program.audience}</p>
            <h3 className="mt-2 font-display text-[2.4rem] font-bold uppercase leading-none sm:text-[3rem]" data-id="element-188" data-mp="3qqqcfxbnco3v">{program.name}</h3>
            <p className="text-pretty mt-5 max-w-[38rem] text-[1.05rem] leading-relaxed text-white/80" data-id="element-189" data-mp="3lqvmbvzp42jv">{program.description}</p>
            <h4 className="mt-8 text-sm font-semibold uppercase tracking-[0.12em] text-white/60" data-id="element-190" data-mp="3hrmsys8ki6ou">In class, students practice</h4>
            <ul className="mt-4 grid gap-x-8 gap-y-3 sm:grid-cols-2" data-id="element-191" data-mp="3cstdwvdmu7mk">
              {program.practices.map(item => <li key={item} className="flex items-start gap-3 text-[15px] leading-snug" data-id="element-192" data-mp="2y4jlt9gmmlky">
                  <span className="mt-[7px] h-[3px] w-4 shrink-0 bg-brand" aria-hidden="true" data-id="element-193" data-mp="333d0v6bkakn8" />
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="flex flex-col border-t border-white/10 p-6 sm:p-10 lg:col-span-5 lg:border-l lg:border-t-0 lg:p-12" data-id="element-194" data-mp="2o8gl881fav04">
            <h4 className="text-sm font-semibold uppercase tracking-[0.12em] text-white/60" data-id="element-195" data-mp="3gu833zrk23hu">A good fit for</h4>
            <p className="text-pretty mt-3 text-lg leading-relaxed" data-id="element-196" data-mp="3lu48o3fwi2zi">{program.goodFit}</p>
            <ButtonLink href={program.id === 'competition-team' ? `${site.emailHref}?subject=${encodeURIComponent('Competition Team inquiry')}` : '#first-class'} onClick={() => {
            if (program.id !== 'competition-team') setTrialChoice(program.id);
          }} className="mt-8 w-full sm:w-auto lg:w-full" icon={<ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-198" data-mp="1t5d9b682dyh0" />} data-id="element-197" data-mp="375honofbwn1y">
              {program.ctaLabel}
            </ButtonLink>

            <div className="mt-auto flex items-center justify-between gap-4 pt-10 text-sm" data-id="element-199" data-mp="1o58tliezd7ru">
              <button type="button" onClick={() => setActiveId(prev.id)} className="inline-flex min-h-[44px] items-center gap-1.5 text-white/70 transition-colors duration-150 hover:text-white" data-id="element-200" data-mp="22u4wl126jull">
                <ChevronLeftIcon className="h-4 w-4" aria-hidden="true" data-id="element-201" data-mp="1a8c0197h9c79" />
                <span className="sr-only" data-id="element-202" data-mp="1598ulnnl53yr">Previous program: </span>
                {prev.name}
              </button>
              <button type="button" onClick={() => setActiveId(next.id)} className="inline-flex min-h-[44px] items-center gap-1.5 text-white/70 transition-colors duration-150 hover:text-white" data-id="element-203" data-mp="1j4ui1qe67fp2">
                <span className="sr-only" data-id="element-204" data-mp="2qjz7ve6upb3q">Next program: </span>
                {next.name}
                <ChevronRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-205" data-mp="3lvz2vg9s0nml" />
              </button>
            </div>
          </div>
        </motion.div>
      </AnimatePresence>
    </div>;
}